
import { BannerData } from "@/types/home";
import { defineComponent, SetupContext, PropType } from "vue";
import BannerIndicatorItem from "./BannerIndicatorItem.vue";

export default defineComponent({
  name: "BannerIndicator",
  components: { BannerIndicatorItem },
  props: {
    /**
     * 表示するバナーのデータ配列
     */
    list: {
      type: Array as PropType<BannerData[]>,
      default: () => []
    },
    /**
     * 表示するIndicatorのid
     */
    position: {
      type: Number,
      require: true
    },
  },
  setup(props, context: SetupContext) {
    const isActive = (id: number) => {
      return (props.position == id);
    }
    return {
      isActive
    };
  }
});
